import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux';
import { FillPause, TrackedPlay, VideoIcon } from '../../Assets/svg';

import { Link, useNavigate } from 'react-router-dom';
import { activeUser } from '../../Store/Slices/APIs';
import Common from '../../Util/common';
import { getPlaylistType, GetSelectedTrackIdByPlaylistType, isVideoUrl, SetPlaylistTrackId, setTrackIdToRandomList, showPlaylistOption } from '../../Util/helpers';
import AddToPlaylistButton from '../BottomPlayerBar/Playlist/AddToPlaylistButton';
import { setIsMixSaved, setMixSavedId } from '../../Store/Slices/SaveMixSlice';
import { addMultipleTracks, addSingleTrack, appendTracksToPlaylist, playAllTracks, removeAllTracks, resetConfig, setConfig, setPlayingConfig, togglePlayPause } from '../../Store/Slices/PlayerSlice';

const AudioStrip = ({ item, type }) => {


    const playlist_config = {
        id: item.id,
        name: item.title,
        data: [item],
        isSavedPlaylist: false,
        playlist_type: getPlaylistType(item)
    };

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const tracks = useSelector((state) => state.player.playingTracks);
    const config = useSelector((state) => state.player.config);
    const isPlaying = useSelector((state) => state.player.isPlaying);

    const [isSelected, setIsSelected] = useState(false);

    const isFeaturedMix = type === Common.CATEGORIES['mix'];
    const isPlaylist = config?.type === "playlist";

    useEffect(() => {
        if (config?.type === "mix") {
            setIsSelected(config['id'] === item.id);
        } else if (config?.type === "playlist") {
            if (config['playlist_type'] === "music_lullaby") {
                setIsSelected(config['shouldPlay'] === item.id);
            } else {
                setIsSelected(config['playingId'] === item.id);
            }
        } else {
            setIsSelected(tracks.some(t => t.id === item.id));
        }
    }, [tracks, config.restartId, config.playingId, config.shouldPlay, item.id]);

    const handleClick = () => {
        if (isVideoUrl(item?.video_url)) {
            navigate(`/audio-detail/${item?.type == Common.RELAXATION ? Common.RELAXREST : item?.type}/${item?.id}`);
        }
    }

    const handleCardClick = () => {

        // 🔹 Reset mix and set the active user
        dispatch(setMixSavedId(null));
        dispatch(activeUser());

        // 🔹 If card is already selected → toggle play/pause
        if (isSelected) {
            dispatch(togglePlayPause());
            return;
        }

        const isTrackInPlaylist = tracks.some(t => t.id === item?.id);

        // 🔹 Handle playlist shuffle mode
        if (isPlaylist && config.isShuffle) {
            setTrackIdToRandomList(item?.id);
        }

        // 🔹 If track already exists in playlist → just play it
        if (isPlaylist && isTrackInPlaylist) {
            dispatch(setConfig({
                playingId: item?.id,
                restartId: item?.id
            }));
            dispatch(playAllTracks());
            return;
        }

        // 🔹 Determine player type and data
        const type = isFeaturedMix ? 'mix' : isPlaylist ? 'playlist' : 'default';
        const data = isPlaylist ? [...tracks, item] : [];

        // 🔹 Prepare player configuration object
        const configObj = {
            id: item?.id,
            type,
            name: (isFeaturedMix || isPlaylist) ? item?.title ?? item?.name : '',
            data,
            playingId: isPlaylist ? config.playlist_ended ? item?.id : config.playingId : null,
            restartId: config.playlist_ended ? item?.id : null,
            isRepeat: isPlaylist ? config.isRepeat : false,
            isShuffle: isPlaylist ? config.isShuffle : false,
            isPlaylist: false,
            isPlaylistMix: config?.isPlaylistMix || false,
            shouldPlay: GetSelectedTrackIdByPlaylistType(item, config),
            playlist_ended: false
        };

        if (config.playlist_ended) {
            SetPlaylistTrackId(data?.id)
        }

        // 🔹 Add or append track(s) based on type
        if (isFeaturedMix) {
            dispatch(addMultipleTracks({ item }));
        } else if (isPlaylist) {
            dispatch(appendTracksToPlaylist([item]));
        } else {
            dispatch(addSingleTrack({ item }));
        }

        // 🔹 Update configuration and start playback
        dispatch(setConfig(configObj));
        dispatch(playAllTracks());


        // OLD CODE - kept for reference
        // // Update mix state
        // dispatch(setMixSavedId(null));

        // // Active User
        // dispatch(activeUser());

        // // Add or remove tracks
        // if (!isSelected) {

        //     const filtered = tracks.some(t => t.id === item?.id);
        //     // If shuffle is enabled and the current config is playlist, add the clicked track to the playedTrackIds set
        //     if (isPlaylist && config.isShuffle) setTrackIdToRandomList(item?.id);

        //     // If the current config is playlist and the clicked item is already in the playlist, just switch to that track
        //     if (isPlaylist && filtered) {
        //         dispatch(setConfig({
        //             playingId: item?.id,
        //             restartId: item?.id
        //         }));
        //         dispatch(playAllTracks());
        //         return;
        //     }

        //     const data = isPlaylist ? [...tracks, ...[item]] : [];
        //     const type = isFeaturedMix ? 'mix' : isPlaylist ? 'playlist' : 'default';
        //     const obj = {
        //         id: item?.id,
        //         type: type,
        //         name: item?.title ?? item?.name,
        //         data: data,
        //         playingId: isPlaylist ? item.id : null,
        //         restartId: isPlaylist ? item.id : null,
        //         isRepeat: isPlaylist ? config.isRepeat : false,
        //         isShuffle: isPlaylist ? config.isShuffle : false,
        //         isPlaylist: false,
        //         isPlaylistMix: false,
        //     }
        //     dispatch(isFeaturedMix ? addMultipleTracks({ item }) : isPlaylist ? appendTracksToPlaylist([item]) : addSingleTrack({ item }));
        //     dispatch(setConfig(obj));
        //     dispatch(playAllTracks());

        // } else {
        //     dispatch(togglePlayPause());
        // }
    };

    return (
        <div className={`audioStrip ${isSelected && 'gradient'}`}>
            <Link to={type === Common.CATEGORIES['mix'] ? `/featured-mixes/${item.id}` : `/audio-detail/${item.type == Common.RELAXATION ? Common.RELAXREST : item.type}/${item.id}`}
                className="audioStripDetails">
                <img src={item?.thumbnail || item?.banner} alt="" />
                <p>{item?.title || item?.name}</p>
            </Link>
            <div className="audioStripExtra">
                <p className="audioStripduration">{item?.tag && item?.tag}</p>
                {isVideoUrl(item?.video_url) ? (
                    <button type="button" className="audioStripButton audioStripPlay" onClick={handleClick}>
                        <img src={VideoIcon} />
                    </button>
                ) : (
                    <button type="button" className="audioStripButton audioStripPlay" onClick={handleCardClick}>
                        {isSelected && isPlaying ? (<img src={FillPause} />) : (<img src={TrackedPlay} />)}
                    </button>
                )}
                {showPlaylistOption(item) && (
                    <AddToPlaylistButton config={playlist_config} />
                )}
            </div>
        </div>
    )
}

export default AudioStrip
